import './App.css';
import ThisOrThatCanvas from './thisorthatcanvas.tsx';

import { AbstractChallenge, weightedRandomNumber } from './abstractchallenge.tsx';
import { INGREDIENTS } from './getIngredients.ts';
import { AbstractCanvasProps } from './abstractcanvas.tsx';

interface ThisOrThatData {
  left: string[],
  right: string[]
}

class ThisOrThat extends AbstractChallenge<ThisOrThatData> {
  title() {
    return "Here's a Scrapbook This OR That Challenge for you...";
  }

  
  reloadButtonText(): string {
    return "Generate New This OR That Challenge";
  }

  getChallengeData(ingredients: INGREDIENTS): ThisOrThatData {
    let numItems = weightedRandomNumber({2: 2, 3:40, 4:30, 5:25, 6:3})
    let groups = ingredients.pickRandomGroups(numItems, 1, 0.4)
    let toAvoid: string[] = [];
    let left = ingredients.sampleGroups(groups, toAvoid);
    let right = ingredients.sampleGroups(groups, toAvoid);
    return {left, right}
  }

  canvas(props: AbstractCanvasProps<ThisOrThatData>) {
    return <ThisOrThatCanvas {...props}/>;
  }
}
 
export default ThisOrThat;
export type {ThisOrThatData};
